import { SelectProps } from "@cofano/cck/Select/Select";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";
import { getCompatibleCalculationMethodsByAgreementType_query } from "view/agreements/utils/AgreementQueries";


const CalculationMethodTypeSelect = ({ agreementType, value, onChange }: Omit<SelectProps<CalculationMethodType, false>, "fetchOptions"> & { agreementType?: AgreementTypeEnum; }) => {
	const client = useApolloClient();

	const onFetchOptions = async() => {
		try {
			const result = await client.query({
				query: getCompatibleCalculationMethodsByAgreementType_query,
				variables: {
					agreementType: agreementType,
				},
			});

			return {
				options: result.data.compatibleCalculationMethodsByAgreementType ?? [],
				totalResults: result.data.compatibleCalculationMethodsByAgreementType?.length ?? 0,
			};
		} catch (ex) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			clearable={false}
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `CALCULATION_METHOD_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default CalculationMethodTypeSelect;
